export default function WalletConnectIcon() {
  return (
    <svg
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.09443 3.2661C7.35599 0.072757 12.644 0.072757 15.9056 3.2661L16.2981 3.65042C16.4612 3.8101 16.4612 4.06896 16.2981 4.22864L14.9554 5.54333C14.8738 5.62317 14.7416 5.62317 14.66 5.54333L14.1199 5.01448C11.8445 2.7867 8.15546 2.7867 5.8801 5.01448L5.30161 5.58083C5.2201 5.66067 5.08791 5.66067 5.00635 5.58083L3.66359 4.26614C3.50047 4.10646 3.50047 3.8476 3.66359 3.68792L4.09443 3.2661ZM18.6826 5.98505L19.8777 7.1551C20.0408 7.31479 20.0408 7.57364 19.8777 7.73333L14.489 13.0094C14.3259 13.1691 14.0615 13.1691 13.8984 13.0094L10.0738 9.26484C10.0331 9.22489 9.96697 9.22489 9.92619 9.26484L6.10172 13.0094C5.93864 13.1691 5.67422 13.1691 5.51114 13.0094L0.122309 7.73328C-0.0407695 7.57359 -0.0407695 7.31474 0.122309 7.15505L1.31739 5.98495C1.48047 5.82531 1.74488 5.82531 1.90795 5.98495L5.7326 9.72958C5.77333 9.76953 5.83942 9.76953 5.88021 9.72958L9.70463 5.98495C9.8677 5.82531 10.1321 5.82531 10.2952 5.98495L14.1198 9.72958C14.1606 9.76953 14.2267 9.76953 14.2675 9.72958L18.092 5.98505C18.2551 5.82536 18.5195 5.82536 18.6826 5.98505Z"
        fill="white"
      />
    </svg>
  );
}
